module.exports = __webpack_public_path__ + "img/workout-alone.dc09cb6f.jpg";